import {CURRENT_USER_COLOR, CURRENT_USER_TEXT, ROLE_IMAGES_MINI, ROLE_NAMES} from "../../../../constants/Constants";
import {useDrop} from "react-dnd";
import drop_tooltip from '../../../../images/roles/drop_tooltip.svg'
import User_SetRoleStat_RoleCard_Mini from "./User_SetRoleState_RoleCard_Mini";
const User_SetRoleStat_UserCard = (props) => {
    const [{ canDrop }, drop] = useDrop(
        () => ({
            accept: 'role',
            drop: props.onDrop,
            collect: (monitor) => ({
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop()
            })
        }),
        ['role', props.onDrop]
    );

    let dropTooltip = null;
    if(canDrop){
        dropTooltip = <img alt={"icon"} src={drop_tooltip} width={100}/>
    }
    let rolesCards = [];
    if(props.user.role){

        let roles = props.user.role;
        for (let i = 0; i < roles.length; i++)
        {
            rolesCards.push(<User_SetRoleStat_RoleCard_Mini
                key={i}
                roleBG={ROLE_IMAGES_MINI[roles[i]]}
                roleTooltip={ROLE_NAMES[roles[i]]}
                role={roles[i]}
                isLast={i === roles.length - 1 && !canDrop}/>)
        }
    }
    let username = `${props.user.firstname} ${props.user.lastname}`;
    let borderStyle = {}
    let textStyle = {}
    if(props.isCurrentPlayer){
        if(props.isCurrentPlayer){
            username += CURRENT_USER_TEXT
            borderStyle = {
                border: '1px solid ' + CURRENT_USER_COLOR
            }
            textStyle = {
                fontWeight: 'bold'
            }
        }

    }
    return <div className='user-set-role-state-user-card-container' ref={drop}>
        <div className='user-set-role-state-user-card-roles-container'>
            {rolesCards}
            {dropTooltip}
        </div>
        <div className='user-set-role-state-user-card-username' style={borderStyle}>
            <div className='user-set-role-username' style={textStyle}>
                {username}
            </div>
        </div>

    </div>

}

export default User_SetRoleStat_UserCard;
